import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities' 

class SharingRepository {

    constructor() {
        this.basePath = store.state.backend;
    }

    getShareLinkByUserId(userId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/community/share-links/user?userId=${userId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }
    getShareLinkByUniqueHash(hash) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/community/share-links/hash?hash=${hash}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getShareLink(linkId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/community/share-links/${linkId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    createShareLink(shareLink) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/community/share-links`, shareLink,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    createShareRequest(shareRequest) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/community/share-requests`, shareRequest,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    updateShareRequest(shareRequest) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/ext/community/share-requests`, shareRequest,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    deleteShareRequest(shareRequestId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/ext/community/share-requests/${shareRequestId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getUsersAvailableForSharing() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/community/search?userId=${store.state.user.id}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    requestedByMeRequests() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/community/share-requests/by-me?userId=${store.state.user.id}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    requestedByOthersRequests() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/community/share-requests/by-others?userId=${store.state.user.id}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    // New method for sharing competition with developer
    shareCompetition(shareData) {
        let headers = {'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/ext/share-competition`, shareData, {headers: headers});
        response = verifyAuth(response);
        return response;
    }
}

export default new SharingRepository();
